export default function _azListing() {
    // check for existing element
    function getElement(select) {
        const element = document.querySelector(select);
        if (element) {
            return element;
        }
        return null;
        // throw new Error(`${select} doesnt exist`);
    }

    const init = (azBanner) => {
        const headerAZLevel = azBanner.dataset.heading;
        const azBannerURL = azBanner.dataset.url;
        const contentContainer = document.querySelector('.content');
        if (contentContainer) {
            const contentElems = [
                ...contentContainer.getElementsByTagName('*'),
            ];
            const contentHeadings = [
                ...contentContainer.querySelectorAll(headerAZLevel),
            ];
            const listingBannerButtons = document.querySelectorAll(
                '.page-banner__list__item'
            );
            const listingBannerLinks = document.querySelectorAll(
                '.page-banner__list__link'
            );
            const pageBannerBtn = document.querySelector(
                '.page-banner__list-btn'
            );
            const lettersArray = [];

            contentHeadings.forEach((item) => {
                const firstLetter = item.innerHTML.charAt(0).toLowerCase();

                const regex = /[a-z]/g;
                const match = firstLetter.match(regex);
                if (match !== null) {
                    const matches = match[0];
                    if (matches && matches.length > 0) {
                        // show  only the alpha chars that exist on the page
                        lettersArray.push(item.innerHTML);
                    }
                }
            });

            const pageBannerURL = window.location.href;

            const lastCharURL = pageBannerURL.slice(-1);

            listingBannerButtons.forEach((letter) => {
                if (letter.children[0].innerHTML === lastCharURL) {
                    letter.classList.add('banner-btn-visited');
                }

                for (const contentHeader of contentHeadings) {
                    if (lastCharURL !== contentHeader.innerHTML.charAt(0)) {
                        // checking if url ends with capital letter or all string
                        if (!pageBannerURL.match(/.[^A-Z][all]$/g)) {
                            contentHeader.classList.add('content-hidden');
                        } else {
                            pageBannerBtn.classList.add('visited-button');
                        }
                    } else {
                        contentHeader.classList.remove('content-hidden');
                    }
                    let contentToHide = '';
                    let contentToShow = '';
                    if (contentHeader.classList.contains('content-hidden')) {
                        contentToHide = contentHeader.nextElementSibling;
                        if (contentToHide) {
                            contentToHide.classList.add('content-hidden');
                        }
                    } else {
                        contentToShow = contentHeader.nextElementSibling;
                        if (contentToShow) {
                            contentToShow.classList.remove('content-hidden');
                        }
                    }
                }

                letter.classList.add('banner-btn-disabled');
                letter.children[0].setAttribute('aria-disabled', 'true');
                letter.children[0].setAttribute('disabled', 'true');
                letter.children[0].classList.add('banner-link-disabled');

                for (const item of lettersArray) {
                    if (
                        letter.children[0].innerHTML.toLowerCase() ===
                        item.charAt(0).toLowerCase()
                    ) {
                        letter.classList.remove('banner-btn-disabled');
                        letter.children[0].setAttribute(
                            'aria-disabled',
                            'false'
                        );
                        letter.children[0].setAttribute('disabled', 'false');
                        letter.children[0].classList.remove(
                            'banner-link-disabled'
                        );
                    }
                }

                const orderedArray = lettersArray.sort();

                for (const item of lettersArray) {
                    if (
                        letter.children[0].innerHTML.toLowerCase() ===
                        item.charAt(0).toLowerCase()
                    ) {
                        if (pageBannerURL.endsWith(azBannerURL)) {
                            letter.classList.add('banner-btn-visited');
                            setTimeout(() => {
                                letter.click();
                            }, 1000);
                        }
                    }
                    break;
                }

                // click on letters
                letter.addEventListener('click', () => {
                    if (pageBannerBtn.classList.contains('visited-button')) {
                        pageBannerBtn.classList.remove('visited-button');
                    }
                    for (const elem of listingBannerButtons) {
                        if (elem.classList.contains('banner-btn-visited')) {
                            elem.classList.remove('banner-btn-visited');
                        }
                    }

                    for (const item of lettersArray) {
                        if (
                            letter.children[0].innerHTML.toLowerCase() ===
                            item.charAt(0).toLowerCase()
                        ) {
                            letter.classList.add('banner-btn-visited');
                        }
                    }

                    for (const contentHeader of contentHeadings) {
                        if (
                            letter.children[0].innerHTML !==
                            contentHeader.innerHTML.charAt(0)
                        ) {
                            contentHeader.classList.add('content-hidden');
                        } else {
                            contentHeader.classList.remove('content-hidden');
                        }
                        let contentToHide = '';
                        let contentToShow = '';
                        if (
                            contentHeader.classList.contains('content-hidden')
                        ) {
                            contentToHide = contentHeader.nextElementSibling;
                            contentToHide.classList.add('content-hidden');
                        } else {
                            contentToShow = contentHeader.nextElementSibling;
                            contentToShow.classList.remove('content-hidden');
                        }
                    }
                });
            });

            // click on See All button
            if (pageBannerBtn) {
                pageBannerBtn.addEventListener('click', () => {
                    if (pageBannerBtn.classList.contains('visited-button')) {
                        pageBannerBtn.classList.remove('visited-button');
                    } else {
                        pageBannerBtn.classList.add('visited-button');
                    }
                    for (const letter of listingBannerButtons) {
                        letter.classList.remove('banner-btn-visited');
                    }
                    for (const elem of contentElems) {
                        elem.classList.remove('content-hidden');
                    }
                });
                pageBannerBtn.click();
            }
        }
    };

    const rotateText = (homeBannerTitle) => {
        const rotatingEl = homeBannerTitle.querySelectorAll(
            '.page-banner__rotating-text'
        );
        const rotatingDelay = Number(homeBannerTitle.dataset.rotatingdelay);
        const totalToRotate = rotatingEl.length;
        const delayBetween = Number(homeBannerTitle.dataset.delaybetween);

        const rotate = (index) => {
            rotatingEl[index].classList.add('active');
            rotatingEl[index].classList.remove('inactive');
            rotatingEl[index].animate(
                { opacity: [0, 0.5, 1] },
                { duration: rotatingDelay, iterations: 1, easing: 'ease-in' }
            ).onfinish = (e) => {
                setTimeout(() => {
                    rotatingEl[index].animate(
                        { opacity: [1, 0.5, 0] },
                        {
                            duration: rotatingDelay,
                            iterations: 1,
                            easing: 'ease-out',
                        }
                    ).onfinish = () => {
                        rotatingEl[index].classList.remove('active');
                        rotatingEl[index].classList.add('inactive');

                        if (index === totalToRotate - 1) {
                            /* eslint-disable */
                            index = 0;
                            /* eslint-enable */
                            rotate(index);
                        } else {
                            rotate(index + 1);
                        }
                    };
                }, delayBetween);
            };
        };

        rotate(0);
    };

    const initRotatingText = (homeBannerTitle) => {
        const rotatingText = homeBannerTitle.dataset.rotatingtext.split(',');

        /* eslint-disable */
        for (const i in rotatingText) {
            const output = `<span class="page-banner__rotating-text rotating-text-${i} inactive">${rotatingText[i]}</span>`;

            homeBannerTitle.insertAdjacentHTML('beforeend', output);
        }
        /* eslint-enable */

        rotateText(homeBannerTitle);
    };

    // setTimeout(() => {
    const azBanner = document.querySelector('.page-banner__body--listing');
    const homeBannerTitle = document.querySelector('.home .page-banner__title');

    if (azBanner) {
        init(azBanner);
    }

    if (homeBannerTitle) {
        initRotatingText(homeBannerTitle);
    }

    // }, 1000);
}

_azListing();
